<template>
  <div v-title data-title="衡水滏阳中学">
    <!-- 头部 -->
    <el-row>
      <header-elem></header-elem>
      <!-- 轮播图 -->
      <rotation-elem></rotation-elem>
    </el-row>
    <!-- 内容主体 -->
    <el-row style="width: 1200px;margin: 0 auto;">
      <el-col :span="24" class="now_position">
        <!-- 当前位置 -->
        <nowposition-elem></nowposition-elem>
      </el-col>
      <el-col :span="24">
        <el-row :gutter="20">
          <div v-for="(subnav,index) in listData" :key="index">
            <el-col :span="12">
              <div class="boxCss list_box">
                <!-- 二级导航 -->
                <div class="box_top">
                  <div class="box_title">{{subnav.catname}}</div>
                  <template v-if="subnav.catid == 14">
                    <router-link class="box_more" :to="{path:'/list',query: {fId:fId, id:subnav.catid, name:name, secondName:subnav.catname}}" tag="a">MORE</router-link>
                  </template>
                  <template v-else>
                    <router-link class="box_more" :to="{path:'/leftNavList',query: {fId:fId, id:subnav.catid, name:name, secondName:subnav.catname}}" tag="a">MORE</router-link>
                  </template>
                </div>
                <!-- 文章列表 -->
                <div class="box_bottom">
                  <ul>
                    <li v-for="(list,i) in subnav.data" :key="i">
                      <div class="underLine_title">
                        <!-- <div
                          v-if="mobileFlag"
                          @click="mobile(list.id, fId, subnav.catid, list.seo_title)"
                          class="article_title"
                        >{{list.title | subStr(35)}}</div> -->
                        <router-link tag="a" :to="{path:'/article',query: {id: list.id, fId: fId, sId: subnav.catid, seo_title:list.seo_title}}" :title="list.title" class="article_title">{{list.title | subStr(35)}}</router-link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-row></el-row>
    <!-- 底部 -->
    <el-row>
      <el-col :span="24">
        <footer-elem></footer-elem>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headerElem from "@/components/com/header";
import rotationElem from "@/components/com/rotation";
import footerElem from "@/components/com/footer";
import nowpositionElem from "@/components/com/nowPosition";

var that;

export default {
  components: {
    "header-elem": headerElem,
    "rotation-elem": rotationElem,
    "footer-elem": footerElem,
    "nowposition-elem": nowpositionElem
  },
  data() {
    return {
      fId: "", //一级栏目的id
      id: "", //二级栏目的id
      name: "", //一级栏目的name
      secondName: "", //二级栏目的name
      listData: [],
      // mobileFlag: ""
    };
  },
  mounted() {
    that = this;
    that.fId = that.$route.query.fId;
    that.name = that.$route.query.name;
    that.id = that.$route.query.id;
    that.secondName = that.$route.query.secondName;
    that.articleList(that.$route.query.id);
    // if (isMobile()) {
    //   that.mobileFlag = true;
    // } else {
    //   that.mobileFlag = false;
    // }
    // console.log(that.mobileFlag);
  },
  beforeRouteUpdate(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    that.id = to.query.id;
    that.name = to.query.name;
    that.articleList(to.query.id);
    next();
  },
  beforeRouteLeave(to, from, next) {
    var position = $(document).scrollTop();
    sessionStorage.setItem("listHei", position);
    next();
  },
  updated() {
    this.$nextTick(function () {
      var position = Number(sessionStorage.getItem("listHei"));
      $(document).scrollTop(position);
    });
  },
  methods: {
    // mobile(id, fId, sId, seo_title) {
    //   location.href =
    //     "http://www.hsfyzx.cn/mobile/index.html#/article?id=" +
    //     id +
    //     "&fId=" +
    //     fId +
    //     "&sId=" +
    //     sId +
    //     "&seo_title=" +
    //     seo_title;
    // },
    articleList(id) {
      $.ajax({
        type: "get",
        url: url + "/archsearch?catid=" + id,
        data: {},
        success: function (data) {
          if (data.code == "0") {
            that.listData = data.data;
          } else if (data.code == "1") {
            that.listData = [];
          }
        },
        error(data) {
          alert(data.msg);
        }
      });
    }
  },
  filters: {
    subStr(val, num) {
      if (val.length > num) {
        return val.substring(0, num) + "...";
      } else {
        return val;
      }
    }
  }
};
</script>
<style scoped>
.el-row {
  margin-bottom: 0;
}
.el-col-12 {
  width: 50% !important;
}
.list_box {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/list.vue